import React from 'react';
import EmailPrefsPage from '../../EmailPrefsPage';

const Prefs = (props) => {
  return <EmailPrefsPage {...props} />;
};

export default Prefs;
